<template>
  <div class="gap-20px flex flex-col justify-self-end">
    <div v-for="(button, key) in buttons" :key="key" :class="btnAlign(button)">
      <Button
        :tag="button.buttonType"
        :link="getButtonUrl(button)"
        :style="button.buttonStyle"
        :width="button.buttonWidth"
        :disabled="button.disabled === true ? true : false">
        {{ button.buttonText }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "../Button.vue";

export default {
  components: {
    Button,
  },

  props: {
    buttons: {
      type: Object,
      required: false,
    },
  },

  setup(props) {
    let getButtonUrl = (button) => {
      return button.buttonType.toLowerCase() === "file"
        ? button.asset.downloadUrl
        : button.url;
    };
    const btnAlign = (button) => {
      if (button.hasOwnProperty("buttonAlignment")) {
        const alignment = button.buttonAlignment;
        switch (alignment) {
          case "left":
            return "text-left";
            break;

          case "right":
            return "text-right";
            break;

          default:
            return "text-center";
            break;
        }
      }

      return false;
    };

    return {
      getButtonUrl,
      btnAlign,
    };
  },
};
</script>
